const baseURL = import.meta.env.VITE_APP_API_URL.replace(/\/$/, '')

const parseBody = async (response) => {
  const text = await response.text()
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

const post = async (url, body) => {
  const isFormData = body instanceof FormData
  const response = await fetch(`${baseURL}/${url.replace(/^\//, '')}`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      ...(body && !isFormData ? { 'Content-Type': 'application/json' } : {}),
    },
    body: body && !isFormData ? JSON.stringify(body) : body,
  })
  const data = await parseBody(response)

  if (!response.ok) {
    const error = new Error(`Request failed with status ${response.status}`)
    error.response = { status: response.status, data }
    throw error
  }

  return { status: response.status, data }
}

export default { post }
